export default __webpack_public_path__ + "static/Pai-e-filha-2a4ad6b11aaba136fc8a76ff4d86131f.jpg";